import api from '../api';

const GLOSSARY_LIST = api.events.glossaryList.actionSuccess;

const defaultState = { list: [] };   

export default (state = defaultState, action) => {
  switch (action.type) {
    case GLOSSARY_LIST:
      return { ...state, list: action.data };
    default:
      return state;
  }
  
};
